import { useSelector } from 'react-redux';
import DuyetKPIGiamDoc from './DuyetKPIGiamDoc';
import DuyetKPIPhongBan from './DuyetKPIPhongBan';
import { maChucVu } from '../../constants';
import DuyetKPIPhoGiamDoc from './DuyetKPIPhoGiamDoc';
const DuyetKPI = () => {
    const user = useSelector((state: any) => state.auth.currentUser);
    if (user.maChucVu === maChucVu.giamDoc) {
        return <DuyetKPIGiamDoc />;
    } else if (user.maChucVu === maChucVu.phoGiamDoc) {
        return <DuyetKPIPhoGiamDoc />;
    } else {
        return <DuyetKPIPhongBan />;
    }
};
export default DuyetKPI;